import { z } from "zod";

import { LocalDateSchema } from "./daily-entry";

export const CircleEventTypeSchema = z.enum(["GOAL_MISSED", "GOAL_COMPLETED"]);

export const CircleEventResponseSchema = z.object({
  id: z.string(),
  circleId: z.string(),
  userId: z.string(),
  displayName: z.string(),
  type: CircleEventTypeSchema,
  localDate: LocalDateSchema,
  goalId: z.string().nullable(),
  goalSlotId: z.string().nullable(),
  goalName: z.string().nullable(),
  slotName: z.string().nullable(),
  message: z.string(),
  createdAt: z.string().datetime(),
});

export const CircleEventsListResponseSchema = z.object({
  events: z.array(CircleEventResponseSchema),
});

export type CircleEventType = z.infer<typeof CircleEventTypeSchema>;
export type CircleEventResponse = z.infer<typeof CircleEventResponseSchema>;
export type CircleEventsListResponse = z.infer<typeof CircleEventsListResponseSchema>;
